import { API_BASE_URL } from "@/config";

export const LOGOUT = {
    data: () => ({
      current_service: null,
    }),
  

    methods: {
        logout() {
            const TOKEN = localStorage.getItem('token');
            const BASE_URL = API_BASE_URL;
            const LOGOUT_URL = `${BASE_URL}/verify_api/system_management_api/logout_api/`;
    
            $.ajax({
            url: LOGOUT_URL,
            method: 'POST',
            contentType: 'application/json',
            headers: {
                Authorization: `Token ${TOKEN}`
            },
            success: (response) => {
                
                if (response.status.toLowerCase() == 'success') {
                    sessionStorage.clear(); 
                    localStorage.clear(); 

                    this.$router.push('/');
                }else{
                    if (this.showError) {
                        this.showError('Could not logout, please try again');
                    } else {
                        console.error('Could not logout, please try again');
                    }
                }
              
            },
            error: () => {
                if (this.showError) {
                    this.showError('Failed to logout, please try again');
                } else {
                    console.error('Failed to logout, please try again');
                }
            }
            });
    
        },
    }
    };